import React from "react";
import DriverList from "../../components/Driver/DriverList/DriverList";

const Driver = () => {
  return (
    <div>
      <DriverList />
    </div>
  );
};

export default Driver;
